"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var gift_cards_1 = require("../../../config/gift-cards");
var isGiftCard = function (skuKey) {
    return skuKey === gift_cards_1.GIFT_CARD_SKU_KEY;
};
exports.default = isGiftCard;
